<template>
  <div class="subsystem-info">
    <div class="subsystem-name">
      <img class="w-100 h-100" :src="logoSource" alt="Alt" />
    </div>
    <div class="about" v-html="about" v-if="about.about"></div>
    <change-log class="text-center" :minimized="true" :lastVersion="true" />
  </div>
</template>

<script>
import ChangeLog from '../changelog/ChangelogPanel'
import { has } from 'lodash'

/**
 * @class SubsystemInfo
 *
 * @description showing information about the system
 */
export default {
  name: 'SubsystemInfo',
  props: {
    activeComponent: {
      type: String,
      default: '',
    },
    logo: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      about: '',
      subSystemName: window.CORE.subSystem.code,
    }
  },
  async created() {
    if (!has(window, 'localStorage.about')) {
      window.localStorage.about = (
        await this.$client.apis['About']['About_findOne']({
          filter: JSON.stringify({
            where: {
              system: window.CORE.subSystem.id,
            },
          }),
        })
      ).body.about
    }
    this.about = window.localStorage.about
  },
  computed: {
    logoSource() {
      return this.$CORE.subSystem.topBarLogo
    },
  },
  components: {
    ChangeLog,
  },
  watch: {
    activeComponent(newValue, oldValue) {
      if (newValue === this.$options.name) {
        this.isActive = true
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.about {
  color: $color-text-secondary;
}
.subsystem-name {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  color: $color-text-secondary;
  padding: 10px 10px 20px 10px;
}
</style>
